import { uploadService } from './../../../../shared/uploadService';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { ServicesService } from '../../services/servicesService';
import { Component, OnInit } from '@angular/core';
import { listKeyitem } from '../../../../shared/Models/SelectItems';
import { Service } from '../../models/ServiceRate';
import { FormMAsterService } from '../../../../DynamicFormsModule/formsMaster/services/formMaster.service';
import { WorkFlowService } from '../../../../workFlowModule/work-flow/work-flow/services/work-flow.service';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';
import { FileVm } from '../../../../shared/Models/fileVm';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-add-service',
  templateUrl: './update-service.component.html',
  styleUrls: ['./update-service.component.css'],
})
export class UpdateServiceComponent implements OnInit {
  isLoading: boolean = false;

  listKeyitem: listKeyitem[] = [];
  model: Service;
  fileName: string;
  file: any;
  formData: FormData;
  attachements: FormData;
  finishLoading = false;
  previousAttachments: FileVm[] = [];
  newPhotoUploaded = false;
  imgURL: any;
  public imagePath;
  public message: string;
  validPhoto: boolean = true;
  serviceId: number;
  inputlist: any[] = [];
  dynmicFormList: any[] = [];
  uploadingVideo: boolean = false;
  videoURL: string = null;
  constructor(
    private service: ServicesService,
    private diagRef: NbDialogRef<UpdateServiceComponent>,
    private toast: NbToastrService,
    private dFormService: FormMAsterService,
    private uploadService: uploadService,
    private wfService: WorkFlowService,
    private route : Router
  ) {
    this.model = {} as Service;
    this.formData = new FormData();
  }
  preview(files) {
    if (files.length === 0) return;
    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }

    const reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    };
    this.file = files;
    this.formData = new FormData();
    for (const filee of this.file) {
      this.fileName = filee.name;
      this.file = filee;
      this.formData.append(filee.name, filee);
    }

    this.newPhotoUploaded = true;
    this.validPhoto = true;
  }
  ngOnInit(): void {
          this.route.events.subscribe(()=>{
      this.diagRef.close('false');
          });
    this.inputlist.push('');
    this.service.getUpdate(this.serviceId).subscribe((res) => {
      this.model = res.entity;
      if (this.model.guideFileName) {
        this.previousAttachments.push({
          fileName: this.model.guideFileName.split('/').pop(),
          path: this.model.guideFileName,
        } as FileVm);

        this.uploadService.updateFiles({ files: [], previousAttachments: this.previousAttachments });
      } else {
        this.uploadService.updateFiles({ files: [], previousAttachments: [] });
      }

      console.log('this.model', this.model);
      this.videoURL = this.model.videoURL;
      this.listKeyitem = res.selectListItems;
      this.wfService.getCreateNew().subscribe((res) => {
        this.dynmicFormList = res[0].values;
      });

      this.finishLoading = true;
    });

    console.log('update Service component');
  }

  get typeValidity() {
    return this.model.serviceTypeId == 0 || !this.model.serviceTypeId ? false : true;
  }
  get benValidity() {
    return this.model.beneficiariesIds == null || this.model.beneficiariesIds.length == 0 ? false : true;
  }

  removePhoot() {
    this.imgURL = null;
    this.file = null;
    this.model.fileName = null;
    this.validPhoto = false;
  }
  uploadFile(evt: any) {
    this.attachements = new FormData();
    for (let file of evt.files) {
      this.attachements.append(file.name, file);
    }
    this.previousAttachments = [];
  }

  //   save() {

  //     debugger
  //     if (!this.validPhoto ){
  //       this.toast.show('يجب تحديد صورة الخدمة', '', { status: 'danger', duration: 3000 });
  //       return
  //     }

  //     let hasAttachments = false;
  //     this.attachements.forEach(() => {
  //       hasAttachments = true;
  //     });

  //     if (this.imgURL != null) {
  //       this.isLoading = true
  //       for (const filee of this.file) {
  //         this.fileName = filee.name;
  //         this.file = filee;
  //         this.formData.append(filee.name, filee);
  //       }
  //       this.isLoading = true

  //       let hasImage = false;
  //       this.formData.forEach(() => {
  //         hasImage = true;
  //       });

  //       if (hasAttachments && hasImage) {
  //       const imgUpload$ = this.service.uploadFile(this.formData);
  //       const attachementsUpload$ = this.service.uploadFile(this.attachements);
  //       combineLatest([imgUpload$, attachementsUpload$])
  //       .subscribe(([img, file]) =>{
  //         this.model.fileName = img.fileName;
  //         this.model.guideFileName = file.fileName;
  //         this.service.put(this.serviceId, this.model).pipe(finalize(() => {this.isLoading = false})).subscribe((resp) => {
  //           this.diagRef.close('true');
  //           this.toast.show('تم تعديل الخدمة جديدة بنجاح', '', { status: 'success', duration: 3000 });
  //         });
  //       });
  //     }

  // else if (hasImage && !hasAttachments) {
  //   this.service.uploadFile(this.formData).subscribe((img) =>{
  //     this.model.fileName = img.fileName;
  //     this.service.put(this.serviceId, this.model).pipe(finalize(() => {this.isLoading = false})).subscribe((resp) => {
  //       this.diagRef.close('true');
  //       this.toast.show('تم تعديل الخدمة جديدة بنجاح', '', { status: 'success', duration: 3000 });
  //     });
  //   })
  // }
  //   }
  //     else {
  // this.isLoading = true
  //       if (hasAttachments) {
  //         this.service.uploadFile(this.attachements).subscribe((file) => {
  //           this.model.guideFileName = file.fileName;
  //           this.service.put(this.serviceId, this.model).pipe(finalize(() => {this.isLoading = false})).subscribe((resp) => {
  //             this.diagRef.close('true');
  //             this.toast.show('تم تعديل الخدمة جديدة بنجاح', '', { status: 'success', duration: 3000 });
  //           });
  //         })
  //       }
  //       else {

  //       this.service.put(this.serviceId, this.model).pipe(finalize(() => {this.isLoading = false})).subscribe((resp) => {
  //         this.diagRef.close('true');
  //         this.toast.show('تم تعديل الخدمة جديدة بنجاح', '', { status: 'success', duration: 3000 });
  //       });
  //     }
  //     }
  //   }

  save() {
    
    let oldPhoto = {} as FileVm;
    if (this.model.fileName) {
      oldPhoto.fileName = this.model.fileName;
    }
    this.isLoading = true;
    const img$ = this.newPhotoUploaded
      ? this.uploadService.uploadImage(this.formData)
      : this.uploadService.uploadImage(oldPhoto);
    const attachments$ = this.uploadService.uploadFile();
    combineLatest([img$, attachments$])
      .pipe(
        switchMap(([img, file]) => {
           this.model.fileName = img.fileName;

        // handle attachment result safely
        if (file) {
          if (Array.isArray(file) && file.length > 0) {
            this.model.guideFileName = file[0].fileName;
          } else if (file.fileName) {
            this.model.guideFileName = file.fileName;
          } else {
            this.model.guideFileName = '';
          }
        } else {
          this.model.guideFileName = '';
        }
          return this.service.put(this.serviceId, this.model);
        }),
        finalize(() => {
          this.isLoading = false;
        }),
        catchError(() => {
          console.log('error here in combine latest ');
          return of(null);
        })
      )
      .subscribe((resp) => {
        this.diagRef.close('true');
        this.toast.show('تم تعديل الخدمة بنجاح', '', { status: 'success', duration: 3000 });
      });
  }

  closePopup() {
    this.diagRef.close('false');
  }

  newStep: string = '';
  newStepEN: string = '';
  keywords: string = '';
  keywordsEN: string = '';
  requiredInfo: string = '';
  requiredInfoEN: string = '';

  addStep() {
    if (this.newStep) {
      if (!this.model.steps) this.model.steps = [];
      this.model.steps.push(this.newStep);
      this.newStep = '';
    }
  }

  removeStep(item) {
    this.model.steps = this.model.steps.filter((x) => x !== item);
  }

  addStepEN() {
    if (this.newStepEN) {
      if (!this.model.stepsEN) this.model.stepsEN = [];
      this.model.stepsEN.push(this.newStepEN);
      this.newStepEN = '';
    }
  }

  removeStepEN(item) {
    this.model.stepsEN = this.model.stepsEN.filter((x) => x !== item);
  }

  addkeyword() {
    if (this.keywords) {
      if (!this.model.keywords) this.model.keywords = [];
      this.model.keywords.push(this.keywords);
      this.keywords = '';
    }
  }

  removeKeyword(item) {
    this.model.keywords = this.model.keywords.filter((x) => x !== item);
  }

  addKeywordsEN() {
    if (this.keywordsEN) {
      if (!this.model.keywordsEN) this.model.keywordsEN = [];
      this.model.keywordsEN.push(this.keywordsEN);
      this.keywordsEN = '';
    }
  }

  removekeywordsEN(item) {
    this.model.keywordsEN = this.model.keywordsEN.filter((x) => x !== item);
  }

  addRequiredInfo() {
    if (this.requiredInfo) {
      if (!this.model.requiredInfo) this.model.requiredInfo = [];
      this.model.requiredInfo.push(this.requiredInfo);
      this.requiredInfo = '';
    }
  }

  removeRequiredInfo(item) {
    this.model.requiredInfo = this.model.requiredInfo.filter((x) => x !== item);
  }

  addRequiredInfoEN() {
    if (this.requiredInfoEN) {
      if (!this.model.requiredInfoEN) this.model.requiredInfoEN = [];
      this.model.requiredInfoEN.push(this.requiredInfoEN);
      this.requiredInfoEN = '';
    }
  }

  removeRequiredInfoEN(item) {
    this.model.requiredInfoEN = this.model.requiredInfoEN.filter((x) => x !== item);
  }

  uploadVideo(evt: any) {
    this.uploadingVideo = true;
    const attachments = new FormData();
    for (let file of evt) {
      attachments.append(file.name, file);
    }

    this.service.uploadFile(attachments).subscribe(
      (res) => {
        this.model.videoURL = res.fileName;
        this.uploadingVideo = false;
      },

      (err) => {
        this.uploadingVideo = false;
      }
    );
  }
}
